import { useState } from 'react';
import { ContactSheet, WorkbookSource } from './workbookImport';

function SheetMapping({ sheet, disabled, onChange }: {
    sheet: ContactSheet;
    disabled: boolean;
    onChange: (headerRowIndex: number, emailColumn: number) => void;
}) {
    const [headerRow, setHeaderRow] = useState(String(sheet.headerRowIndex + 1));
    const [emailColumn, setEmailColumn] = useState(String(sheet.emailColumn));
    const validRow = /^\d+$/.test(headerRow) && Number(headerRow) <= sheet.lastRow;
    return (
        <details className="workbook-sheet-mapping">
            <summary>设置表头与邮箱列</summary>
            <div>
                <label className="bulk-field"><span>表头行号（0 表示无表头）</span>
                    <input className="input" type="number" min="0" max={sheet.lastRow} value={headerRow} disabled={disabled} onChange={(event) => setHeaderRow(event.target.value)} />
                </label>
                <label className="bulk-field"><span>邮箱所在列</span>
                    <select className="input" value={emailColumn} disabled={disabled} onChange={(event) => setEmailColumn(event.target.value)}>
                        <option value="-1">请选择邮箱列</option>
                        {sheet.columns.map((column) => <option key={column.index} value={column.index}>{column.label}</option>)}
                    </select>
                </label>
                <button type="button" className="btn btn-outline btn-sm" disabled={disabled || !validRow || Number(emailColumn) < 0} onClick={() => onChange(Number(headerRow) - 1, Number(emailColumn))}>应用并重新检查</button>
            </div>
            <p>行号与 Excel 左侧一致；请在下方预览中核对邮箱和对应联系人。</p>
        </details>
    );
}

export function WorkbookSheetPicker({ source, disabled, onSelect, onMapping, onRecheck, purpose = 'import' }: {
    source: WorkbookSource;
    disabled: boolean;
    onSelect: (name: string, selected: boolean) => void;
    onMapping: (name: string, headerRowIndex: number, emailColumn: number) => void;
    onRecheck: () => void;
    purpose?: 'import' | 'verification';
}) {
    const selected = source.sheets.filter((sheet) => sheet.selected && !sheet.issue);
    return (
        <div className="workbook-sheet-picker" aria-label="工作表识别与选择">
            <div className="workbook-sheet-heading">
                <div><strong>共 {source.sheets.length} 张工作表 · 已选择 {selected.length} 张</strong>
                    <p>{purpose === 'verification' ? '检查勾选工作表中的邮箱，保留原表资料。' : '勾选的工作表会合并到所选活动。'}未识别的表可手动设置；隐藏表默认不选。</p></div>
                <button type="button" className="btn btn-outline btn-sm" disabled={disabled || !selected.length} onClick={onRecheck}>重新检查</button>
            </div>
            <div className="workbook-sheet-list">
                {source.sheets.map((sheet) => (
                    <div className={`workbook-sheet ${sheet.issue ? 'needs-mapping' : ''}`} key={sheet.name}>
                        <label className="workbook-sheet-choice">
                            <input type="checkbox" checked={sheet.selected} disabled={disabled || Boolean(sheet.issue)} onChange={(event) => onSelect(sheet.name, event.target.checked)} />
                            <span><strong>{sheet.name}{sheet.hidden ? '（隐藏表）' : ''}</strong>
                                <small>{sheet.issue || `${sheet.rows.length.toLocaleString()} 行 · ${sheet.headerRowIndex < 0 ? '无表头' : `表头在第 ${sheet.headerRowIndex + 1} 行`} · 邮箱列 ${sheet.columns.find((column) => column.index === sheet.emailColumn)?.label}`}</small></span>
                        </label>
                        {sheet.columns.length > 0 && <SheetMapping key={`${sheet.name}:${sheet.headerRowIndex}:${sheet.emailColumn}`} sheet={sheet} disabled={disabled} onChange={(headerRowIndex, emailColumn) => onMapping(sheet.name, headerRowIndex, emailColumn)} />}
                    </div>
                ))}
            </div>
        </div>
    );
}
